// Wallpaper configuration for Pink Pixel OS
// Add new gradient presets or photo wallpapers here.
// To add a new photo wallpaper:
// 1. Drop your image file into /public/wallpapers (e.g. galaxy.jpg)
// 2. Add an entry below with a unique id and name.
// 3. That's it – it becomes selectable in the UI & context menu.

export const gradientPresets = [
  {
    id: 'pinkNebula',
    name: 'Pink Nebula',
    classes: 'bg-gradient-to-br from-pink-900 via-purple-900 to-gray-900'
  },
  {
    id: 'cyberCandy',
    name: 'Cyber Candy',
    classes: 'bg-gradient-to-br from-fuchsia-800 via-pink-700 to-rose-800'
  },
  {
    id: 'auroraDream',
    name: 'Aurora Dream',
    classes: 'bg-gradient-to-br from-indigo-900 via-purple-800 to-pink-700'
  },
  {
    id: 'oceanNight',
    name: 'Ocean Night',
    classes: 'bg-gradient-to-br from-blue-900 via-indigo-900 to-cyan-800'
  },
  {
    id: 'sunsetBliss',
    name: 'Sunset Bliss',
    classes: 'bg-gradient-to-br from-amber-700 via-rose-700 to-fuchsia-800'
  }
]

// Built‑in photo wallpapers.
// These files should exist under /public/wallpapers.
export const photoWallpapers = [
  { id: 'pinkPixel', name: 'Pink Pixel', src: '/wallpapers/pinkpixel.webp' },
  { id: 'cloudwerx', name: 'Cloudwerx', src: '/wallpapers/cloudwerx.webp' },
  { id: 'pixelHearts', name: 'Pixel Hearts', src: '/wallpapers/pixel-hearts.webp' },
  { id: 'pixelUnicorns', name: 'Pixel Unicorns', src: '/wallpapers/pixel-unicorns.webp' },
  { id: 'serverCats', name: 'Server Cats', src: '/wallpapers/server-cats.webp' },
  { id: 'candyland', name: 'Candyland', src: '/wallpapers/candyland.webp' },
  { id: 'cyberpunkCity', name: 'Cyberpunk City', src: '/wallpapers/cyberpunk_city.webp' },
  { id: 'tokyoNight', name: 'Tokyo Night', src: '/wallpapers/tokyo-night.webp' },
  { id: 'neonWaves', name: 'Neon Waves', src: '/wallpapers/neon_waves.webp' },
  { id: 'tech', name: 'Tech', src: '/wallpapers/tech.webp' },
  { id: 'neuroBall', name: 'Neuro Ball', src: '/wallpapers/neuro-ball.webp' },
  { id: 'geometricBlack', name: 'Geometric Black', src: '/wallpapers/geometric-black.webp' },
  { id: 'astronaut', name: 'Astronaut', src: '/wallpapers/astronaut.webp' },
  { id: 'starryNight', name: 'Starry Night', src: '/wallpapers/starry-night.webp' },
  { id: 'northernLights', name: 'Northern Lights', src: '/wallpapers/northern_lights.webp' },
  { id: 'artisticSunrise', name: 'Artistic Sunrise', src: '/wallpapers/artistic_sunrise.webp' },
  { id: 'tropicalSunset', name: 'Tropical Sunset', src: '/wallpapers/tropical_sunset.webp' },
  { id: 'oceanScene', name: 'Ocean Scene', src: '/wallpapers/ocean-scene.webp' },
  { id: 'etherealForest', name: 'Ethereal Forest', src: '/wallpapers/ethereal-forest.webp' },
  { id: 'darkForest', name: 'Dark Forest', src: '/wallpapers/dark-forest.webp' },
  { id: 'flowerArt', name: 'Flower Art', src: '/wallpapers/flower-art.webp' }
]

export const DEFAULT_WALLPAPER = { kind: 'gradient', value: 'auroraDream' }
